import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';

@Injectable()
export class ClientesPymesService {

  
  CLnombre:string = "";
  CLcif:string = "";
  CLemail:string = "";
  CLtelefono:string = "";
  CLactivo:number=1;
  CLfechaultimoacceso="";

  clientes:any[]=[];
  direcciones:any[]=[];
  clienteActual={};
  listaClientes=[];

  documento;
  categoriasLaboral;
  categoriasFiscal;
  categoriasContable;
  categoriaActual;
  constructor(private http:HttpClient) { }

  getClientes( filtro, pagina, ordenacion ){
    filtro.nombre==""?this.CLnombre="-":this.CLnombre=encodeURI(filtro.nombre);
    filtro.email==""?this.CLemail="-":this.CLemail=encodeURI(filtro.email);
    filtro.telefono==""?this.CLtelefono="-":this.CLtelefono=encodeURI(filtro.telefono);
    filtro.cif==""?this.CLcif="-":this.CLcif=encodeURI(filtro.cif);
    filtro.activo==true?this.CLactivo=1:this.CLactivo=0;
    filtro.ultimoacceso==""?this.CLfechaultimoacceso="-":this.CLfechaultimoacceso=filtro.ultimoacceso;
    
    let CLnombre=this.CLnombre;
    return this.http.post( `https://app.solucionlegal.es/API/index.php/Clientes_pymes/clientes/${this.CLcif}/${this.CLemail}/${this.CLtelefono}/${this.CLactivo}/${this.CLfechaultimoacceso}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {CLnombre} )
                      .map( res=>{
                        
                        this.clientes=res["clientes_pymes"];
                        return res;
                      });
  }

  insertCliente( cliente ){
    
    let body= JSON.stringify(cliente);
    
    return this.http.post( `https://app.solucionlegal.es/API/index.php/Clientes_pymes/createcliente`, body)
      .map( res=>{
        
        return res;
      });
  }

  updateCliente( cliente, archivo ){
    
    let formData:FormData=new FormData();
    
    if(archivo){
      formData.append("filekey", archivo, archivo.name);
    }
      formData.append("cliente", JSON.stringify(cliente));
    
      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/updatecliente/`, formData)
      .map(res=>{
        
        return res;
      });
  }

  getCliente(codigo:any){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/cliente/${codigo}`)
                    .map(res=>{
                      
                      this.clienteActual=res["cliente_pymes"];
                      return this.clienteActual;
                    });
  }

  getNombresClientes(){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/nombresclientes`)
    .map(resp=>{
      this.listaClientes=resp["clientes"];
      return true;
    })
  }

  actualizarEstado(codigo){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/updateestado/${codigo}`)
    .map(resp=>{
      
      return resp;
    })
  }

  cambiarPass(cliente){
    let body=JSON.stringify(cliente);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/cambiarPass`, body)
    .map(resp=>{
      return resp;
    });
  }

  cargarCategoriasLaboral(codCliente, anio){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/Categorias/${codCliente}/${anio}/L`)
    .map(resp=>{
      this.categoriasLaboral=resp["categorias"];
      return this.categoriasLaboral;
    });
  }

  cargarCategoriasFiscal(codCliente, anio){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/Categorias/${codCliente}/${anio}/F`)
    .map(resp=>{
      this.categoriasFiscal=resp["categorias"];
      return this.categoriasFiscal;
    });
  }

  cargarCategoriasContable(codCliente, anio){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/Categorias/${codCliente}/${anio}/C`)
    .map(resp=>{
      this.categoriasContable=resp["categorias"];
      return this.categoriasContable;
    });
  }
  

  AniosLaboral(codCliente){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/aniosLaboral/${codCliente}`)
    .map(resp=>{
      return resp["anios"];
    });
  }

  AniosFiscal(codCliente){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/aniosFiscal/${codCliente}`)
    .map(resp=>{
      return resp["anios"];
    });
  }

  AniosContable(codCliente){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/aniosContable/${codCliente}`)
    .map(resp=>{
      return resp["anios"];
    });
  }

  cargarDocumentos(codpadre, codtipodoc){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/documentos/${codpadre}/${codtipodoc}`)
    .map(resp=>{
      return resp["documentos"];
    });
  }

  cargarDocumentosContable(codcliente, anio, codtipodoc){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/documentosContable/${codcliente}/${anio}/${codtipodoc}`)
    .map(resp=>{
      return resp["documentos"];
    });
  }



  cargarMes(codcategoria){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/mesAnio/${codcategoria}`)
    .map(resp=>{
      
      return resp["mesAnio"];
    });
  }

  cargarCategoriaActual(codcategoria){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/categoria/${codcategoria}`)
    .map(resp=>{
      this.categoriaActual=resp["categoria"];
      return resp;
    })
  }

  cargarTiposDoc(tipoServicio){
    
    switch(tipoServicio){
      case 'L':
          return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/tiposLaboral`)
          .map(resp=>{
            return resp["tipos"];
          });
      
      case 'F':
          return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/tiposFiscal`)
          .map(resp=>{
            return resp["tipos"];
          });
      
      case 'C':
          return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/tiposContable`)
          .map(resp=>{
            return resp["tipos"];
          });
      
    }
  }

  cargarDocumento(iddoc){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/documento/${iddoc}`)
          .map(resp=>{
            return resp;
          });
  }

  nuevoAnioLaboral(anio){
    let idcliente=this.clienteActual["CLcodigo"];
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/anioLaboral`,{idcliente, anio})
          .map(resp=>{
            return resp;
          });
  }

  nuevoAnioFiscal(anio){
    let idcliente=this.clienteActual["CLcodigo"];
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/anioFiscal`,{idcliente, anio})
          .map(resp=>{
            return resp;
          });
  }

  nuevoAnioContable(anio){
    let idcliente=this.clienteActual["CLcodigo"];
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/anioContable`,{idcliente, anio})
          .map(resp=>{
            return resp;
          });
  }

  insertDoc(documento, archivo){

    documento["PDcodcliente"]=this.categoriaActual["DLidcliente"];
    documento["PDcodtipo"]=this.categoriaActual["DLtipo"];
    documento["PDanio"]=this.categoriaActual["DLanio"];
    documento["PDidpadre"]=this.categoriaActual["DLid"];

    let formData:FormData=new FormData();

    formData.append("filekey", archivo, archivo.name);
    formData.append("documento", JSON.stringify(documento));
    
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/insertDoc`, formData)
    .map(resp=>{
      return resp;
    });
  }

  updateDoc(documento){
    let body=JSON.stringify(documento);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes_pymes/updateDoc`, body)
    .map(resp=>{
      return resp;
    })
  }

  descargarDoc(ruta:string){
    //let headers=new Headers();
    //headers.append('response-type','arraybuffer');
    return this.http.post(`https://app.solucionlegal.es/API/index.php/clientes_pymes/descargarDoc`,{ruta},{responseType:'arraybuffer'})
    .map(res=>new Blob([res],{ type: 'application/pdf' }));
  }

  borrarDoc(codigoDoc){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/documento/${codigoDoc}`)
    .map(resp=>{
      return resp;
    });
  }

  getListaClientes(){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/clientes_pymes/nombresClientes`)
    .map(resp=>{
      this.listaClientes=resp["clientes_pymes"];
    })
  }

  borrarAnio(codcliente, tipo, anio){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/anio/${codcliente}/${tipo}/${anio}`)
    .map(resp=>{
      return resp;
    });
  }

  borrarCliente(codcliente){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/clientes_pymes/cliente/${codcliente}`)
    .map(resp=>{
      return resp;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/clientes-pymes.service.ts